import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputSearch } from '@/pcomponents/common/date_picker/custom_input';

function SearchDateArea(props: any) {
  let myProps = {
    listOpt: {},
    list: (inData: any) => { },
    xColumnArr: {},
    ...props,
  };
  let listOpt = props.listOpt;

  const handleInputChange = (event: any) => {
    const target = event.target;
    let value: any = target.value;
    const name = target.name;
    if (target.type === 'checkbox' || target.type === 'radio') {
      value = "";
      if (target.checked) {
        value = target.value;
      }
    }

    myProps.list({ now_page: 1, [name]: value });
  };

  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    myProps.list({ now_page: 1, [key]: date_str });
  };

  const goDateDayChange = (sort: "pre" | "next") => {
    //next,pre
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    selected_date=DateFunc.get_date_format(new Date(selected_date), "Y-m-01");
    let change_date_obj = new Date(selected_date);
    if (sort == "pre") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', -1);
    } else if (sort == "next") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', +1);
    }

    let start_date = DateFunc.get_date_format(change_date_obj, "Y-m-01");
    let end_date = DateFunc.get_date_format(change_date_obj, "Y-m-t");
    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  return (
    <div style={{display:"inline-block",width:"400px"}}>
      입학일
      <div style={{ display: "inline-block", width: 90 }}>
        <DatePicker
          wrapperClassName="pl-1"
          selected={listOpt.s_start_date != "" ? new Date(listOpt.s_start_date) : null}
          onChange={(date: Date) => {
            onChangeDatePicker("s_start_date", date);
          }}
          locale={ko}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInputSearch />}
          renderCustomHeader={customHeaderFunc}
        />
      </div>
      ~
      <div style={{ display: "inline-block", width: 90 }}>
        <DatePicker
          wrapperClassName="pl-1"
          selected={listOpt.s_end_date != "" ? new Date(listOpt.s_end_date) : null}
          onChange={(date: Date) => {
            onChangeDatePicker("s_end_date", date);
          }}
          locale={ko}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInputSearch />}
          renderCustomHeader={customHeaderFunc}
        />
      </div>
      <button className="btn-s2 btn-yellowish2 ml-2" onClick={() => { goDateDayChange("pre"); }}>◀</button>
      <button className="btn-s2 btn-yellowish2 ml-1" onClick={() => { goDateDayChange("next"); }}>▶</button>
      {/* <button className="btn-s2 btn-sky ml-2" onClick={() => {
        myProps.list({
          "now_page": 1,
          s_start_date: DateFunc.get_date_format(DateFunc.get_change_date(new Date(), 'month', -1), "Y-m-01"),
          s_end_date: DateFunc.get_date_format(new Date(), "Y-m-t")
        });
      }}>지난달</button>
      <button className="btn-s2 btn-sky ml-1" onClick={() => {
        myProps.list({
          "now_page": 1,
          s_start_date: DateFunc.get_date_format(new Date(), "Y-m-01"),
          s_end_date: DateFunc.get_date_format(new Date(), "Y-m-t")
        });
      }}>이번달</button>
      <button className="btn-s2 btn-sky ml-1" onClick={() => {
        myProps.list({
          "now_page": 1,
          s_start_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
          s_end_date: DateFunc.get_date_format(new Date(), "Y-m-d")
        });
      }}>오늘</button>
      <button className="btn-s2 btn-sky ml-1" onClick={() => {
        let now_y_m_d = DateFunc.get_date_format(new Date(), "Y-m-01");
        let ago_6_month = DateFunc.get_change_date(new Date(now_y_m_d), 'month', -6);
        myProps.list({
          "now_page": 1,
          s_start_date: DateFunc.get_date_format(ago_6_month, "Y-m-01"),
          s_end_date: DateFunc.get_date_format(new Date(), "Y-m-t")
        });
      }}>6개월</button>
      <button className="btn-s2 btn-sky ml-1" onClick={() => {
        myProps.list({
          now_page: "1",
          s_start_date: "",
          s_end_date: "",
        });
      }}>전체</button> */}
    </div>
  );
};

export default SearchDateArea;